import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromEquipment from '../_reducers/equipment';

export const selectEquipmentState =
  createFeatureSelector<fromEquipment.EquipmentState>('equipments');

export const selectAllEquipments = createSelector(selectEquipmentState, fromEquipment.selectAll);

export const selectEquipmentEntities = createSelector(
  selectEquipmentState,
  fromEquipment.selectEntities
);

export const selectEquipmentById = (id: number) =>
  createSelector(selectEquipmentEntities, (entities) => entities[id]);

export const selectEquipmentTotal = createSelector(selectEquipmentState, fromEquipment.selectTotal);
